import { useEffect, useState } from "react";
import {
  slugify,
} from "../../data/cmsStore";
import { cmsAdminApi } from "../../api/cmsApi";

const emptyForm = {
  id: "",
  title: "",
  slug: "",
  categoryId: "",
  location: "",
  type: "Full-time",
  experience: "",
  salary: "",
  department: "",
  openings: "1",
  description: "",
  responsibilities: "",
  requirements: "",
  benefits: "",
  status: "open",
  postedAt: new Date().toISOString().slice(0, 10),
};

export default function AdminJobsPage() {
  const [jobs, setJobs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState("");

  const refresh = async () => {
    try {
      const [jobsData, catData] = await Promise.all([
        cmsAdminApi.listJobs(),
        cmsAdminApi.listJobCategories(),
      ]);
      setJobs(jobsData);
      setCategories(catData);
      setError("");
    } catch (e) {
      setError(e.message || "Could not load jobs");
    }
  };
  useEffect(() => {
    refresh();
  }, []);
  const catName = (id) => categories.find((c) => c.id === id)?.name || "—";

  const openCreate = () => {
    setForm({ ...emptyForm, categoryId: categories[0]?.id || "" });
    setEditing(true);
  };

  const openEdit = (job) => {
    setForm({ ...job });
    setEditing(true);
  };

  const onSave = async (e) => {
    e.preventDefault();
    await cmsAdminApi.saveJob(form);
    setEditing(false);
    setForm(emptyForm);
    await refresh();
  };

  const onDelete = async (id) => {
    if (!window.confirm("Delete this job?")) return;
    await cmsAdminApi.deleteJob(id);
    await refresh();
  };

  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <div>
          <h1>Jobs</h1>
          <p>Create and manage career openings.</p>
        </div>
        <button type="button" className="admin-btn admin-btn-primary" onClick={openCreate}>
          <i className="bi bi-plus-lg" /> Add job
        </button>
      </header>
      {error ? <p className="text-danger">{error}</p> : null}

      {editing ? (
        <form className="admin-panel admin-form" onSubmit={onSave}>
          <div className="admin-panel-head">
            <h2>{form.id ? "Edit job" : "New job"}</h2>
            <button type="button" className="admin-btn admin-btn-ghost" onClick={() => setEditing(false)}>Cancel</button>
          </div>
          <div className="admin-form-grid">
            <label>Title
              <input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value, slug: form.id ? form.slug : slugify(e.target.value) })} />
            </label>
            <label>Slug
              <input required value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} />
            </label>
            <label>Category
              <select required value={form.categoryId} onChange={(e) => setForm({ ...form, categoryId: e.target.value })}>
                <option value="">Select</option>
                {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </label>
            <label>Location
              <input value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} />
            </label>
            <label>Type
              <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
                <option>Full-time</option>
                <option>Part-time</option>
                <option>Contract</option>
                <option>Internship</option>
              </select>
            </label>
            <label>Experience
              <input value={form.experience} onChange={(e) => setForm({ ...form, experience: e.target.value })} />
            </label>
            <label>Salary
              <input value={form.salary} onChange={(e) => setForm({ ...form, salary: e.target.value })} />
            </label>
            <label>Department
              <input value={form.department || ""} onChange={(e) => setForm({ ...form, department: e.target.value })} />
            </label>
            <label>Openings
              <input value={form.openings || ""} onChange={(e) => setForm({ ...form, openings: e.target.value })} />
            </label>
            <label>Status
              <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
              </select>
            </label>
            <label>Posted date
              <input type="date" value={form.postedAt} onChange={(e) => setForm({ ...form, postedAt: e.target.value })} />
            </label>
            <label className="admin-form-span">Description
              <textarea rows={4} required value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
            </label>
            <label className="admin-form-span">Responsibilities (one per line)
              <textarea rows={4} value={form.responsibilities || ""} onChange={(e) => setForm({ ...form, responsibilities: e.target.value })} />
            </label>
            <label className="admin-form-span">Requirements (one per line)
              <textarea rows={4} value={form.requirements} onChange={(e) => setForm({ ...form, requirements: e.target.value })} />
            </label>
            <label className="admin-form-span">Benefits (one per line)
              <textarea rows={3} value={form.benefits || ""} onChange={(e) => setForm({ ...form, benefits: e.target.value })} />
            </label>
          </div>
          <div className="admin-form-actions">
            <button type="submit" className="admin-btn admin-btn-primary">Save job</button>
          </div>
        </form>
      ) : null}

      <div className="admin-panel">
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Role</th>
                <th>Category</th>
                <th>Location</th>
                <th>Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {jobs.map((j) => (
                <tr key={j.id}>
                  <td><strong>{j.title}</strong><div className="text-muted small">{j.type} · {j.experience}</div></td>
                  <td>{catName(j.categoryId)}</td>
                  <td>{j.location}</td>
                  <td><span className={`admin-pill admin-pill--${j.status}`}>{j.status}</span></td>
                  <td className="admin-actions">
                    <button type="button" className="admin-btn admin-btn-sm" onClick={() => openEdit(j)}>Edit</button>
                    <button type="button" className="admin-btn admin-btn-sm admin-btn-danger" onClick={() => onDelete(j.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
